
















































import {Component, Vue} from "vue-property-decorator"
import Gravatar from "@/components/Gravatar.vue"
import {vxm} from "@/store"
import {FlushMessageType, User} from "@/interface"
import {Validation} from "@/lib/Validation"
import ErrorMessage from "@/components/ErrorMessage.vue"

@Component({components: {Gravatar, ErrorMessage}})
export default class ChangePassword extends Vue {

  private me: User | null = null

  private current_password: string = ""
  private new_password: string = ""
  private re_new_password: string = ""

  private errors: object = {}

  private loading: boolean = false

  async mounted() {
    this.me = vxm.auth.user
  }

  async onSave() {

    this.errors = {}
    if (!this.validate()) return

    this.loading = true
    try {
      await vxm.auth.changePassword({
        previous_password: this.current_password,
        proposed_password: this.new_password
      })
      vxm.app.addFlushMessage({
        type   : FlushMessageType.SUCCESS,
        message: "Password change successful"
      })
      this.current_password = ""
      this.new_password = ""
      this.re_new_password = ""
    } catch (e) {
      if (e && e.hasOwnProperty("code")) {
        switch (e.code) {
          default:
            this.errors = {general: [e.message]}
            console.error(e)
        }
      } else {
        this.errors = {general: ["Server Error."]}
        console.error("不明なエラー", e)
      }

      vxm.app.addFlushMessage({
        type   : FlushMessageType.ERROR,
        message: "An error has occurred"
      })
      console.error(e)
    } finally {
      this.loading = false
    }
  }

  validate(): boolean {

    if (this.new_password !== this.re_new_password) {
      this.errors = {general: ['Passwords do not match']}
      return false
    }

    const validation = new Validation({
      current_password: {required: true},
      new_password    : {required: true},
      re_new_password : {required: true}
    })

    const check: boolean = validation.validate({
      current_password: this.current_password,
      new_password    : this.new_password,
      re_new_password : this.re_new_password
    })

    if (!check) this.errors = validation.getErrors()


    return check
  }
}

